






















































import Component from 'vue-class-component';
import Vue from 'vue';
import OfficeProgressCriteria from './office-progress-criteria.vue';
import * as ent from '@/entities';
import statsApi from '@/api/stats.api';
import { MasterPage } from '@/components/base/master/master-page';

@Component({
    components: {
        'office-progress-criteria': OfficeProgressCriteria
    }
})
export default class OfficeProgress extends MasterPage {
    public items: ent.IStatPeriodItemModel[] = null;
    public loading: boolean = false;
    public criteria: ent.IGetPeriodsStatsModel = null;

    protected defaultSort: ent.ISort = {
        field: 'name',
        asc: true
    };

    public get period1Str() {
        if (!this.criteria) {
            return '';
        }
        return ent.formatPeriod(this.criteria.period1);
    }

    public get period2Str() {
        if (!this.criteria) {
            return '';
        }
        return ent.formatPeriod(this.criteria.period2);
    }

    public getItemClass(item: ent.IStatPeriodItemModel) {
        if (item.progress > 0) {
            return 'success';
        } else {
            return 'fail';
        }
    }


    public criteriaChange(body: ent.IGetPeriodsStatsModel) {
        this.criteria = body;
        this.search();
    }

    public async search() {
        if (!this.criteria) {
            return;
        }
        this.loading = true;
        this.items = null;
        try {
            this.items = await statsApi.periods({
                ...this.criteria,
                sortField: this.sort.field,
                sortAsc: this.sort.asc
            });
        } finally {
            this.loading = false;
        }
    }
}
